import { default as Representative } from './Representative'

export default Representative
